<ng-container *ngIf="vm$ | async as vm">
    <app-form-single-select
        (valueChange)="dateRangeOptionChange($event)"
        [value]="vm.value"
        [options]="vm.entities"
        [canClear]="vm.clearbale"
        [placeholder]="vm.periodPlaceholder"
    ></app-form-single-select>
</ng-container>